// Mirror of the default plans/config (only for the "Importar padrões" button when
// Firestore has no plans yet). The runtime source of truth is Firestore.
// Keeps parity with functions/config/plans.js.

export const DEFAULT_PLANS = [
  { planId: 'trial',   label: 'Trial',   maxChannels: 1, maxAgents: 2,  maxMessagesPerMonth: 500,   features: { audio: true },  archived: false, order: 1 },
  { planId: 'starter', label: 'Starter', maxChannels: 1, maxAgents: 3,  maxMessagesPerMonth: 3000,  features: { audio: false }, archived: false, order: 2 },
  { planId: 'pro',     label: 'Pro',     maxChannels: 3, maxAgents: 10, maxMessagesPerMonth: 20000, features: { audio: true },  archived: false, order: 3 },
];

export const DEFAULT_SETTINGS = { graceDays: 3, trialDays: 14 };
